var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { DropdownItemStructure } from '../components/DropdownItemStructure';
import { PrefixLabel } from '../../PrefixLabel';
import { Paragraph } from '../../Paragraph';
import { Icon } from '../../Icon';
// Styles
import { getDropdownItemStylesByVariant } from './getDropdownItemStylesByVariant';
import { getSquareIconStyles } from '../../../common/styles/getSquareIconStyles';
// Utils
import styled from 'styled-components';
import { DropdownItemState } from '../types/DropdownItemProps';
/**
 * @deprecated this has been deprecated in favour of the LineItem component.
 */
export var StyledDropdownItem = styled(DropdownItemStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: minmax(0, max-content) 1fr;\n  align-content: center;\n  align-items: center;\n  height: 16px;\n  padding: 4px;\n\n  outline: none;\n\n  cursor: ", ";\n\n  ", " {\n    margin-right: 4px;\n  }\n\n  ", " {\n    ", ";\n    margin-right: 4px;\n  }\n\n  ", " {\n    display: inline-block;\n  }\n\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: minmax(0, max-content) 1fr;\n  align-content: center;\n  align-items: center;\n  height: 16px;\n  padding: 4px;\n\n  outline: none;\n\n  cursor: ",
    ";\n\n  ", " {\n    margin-right: 4px;\n  }\n\n  ", " {\n    ", ";\n    margin-right: 4px;\n  }\n\n  ", " {\n    display: inline-block;\n  }\n\n  ", ";\n"])), function (_a) {
    var state = _a.state;
    return state === DropdownItemState.DISABLED || state === DropdownItemState.SELECTED ? 'default' : 'pointer';
}, PrefixLabel, Icon, getSquareIconStyles('12px'), Paragraph, function (_a) {
    var state = _a.state, theme = _a.theme, styleVariant = _a.styleVariant;
    return getDropdownItemStylesByVariant(state, theme, styleVariant);
});
var templateObject_1;
//# sourceMappingURL=StyledDropdownItem.js.map